import { useTranslation } from 'react-i18next';

export function ArbeitszeitTrigger() {
  const { t } = useTranslation();
  return <div>{t('domain.arbeitszeiten.sheet.tabs.arbeitszeit')}</div>;
}
